import { createFileRoute, notFound, stripSearchParams } from "@tanstack/react-router";

import { caseTemplatesQueries } from "@/api/resources/caseTemplates/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { CaseTemplatesPage } from "@/components/CaseTemplate/CaseTemplatesPage";
import { dataTableSearchSchema, DEFAULT_DATATABLE_OPTIONS } from "@/configs/datatable";
import i18n from "@/providers/i18n";
import { Icon } from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/")({
  validateSearch: dataTableSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_DATATABLE_OPTIONS)],
  },
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.knowledge-hub-case-templates"),
        icon: <Icon.CASE_TEMPLATES />,
        path: "/workspaces/$workspace_id/knowledge-hub/case-templates",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();

    await context.queryClient.ensureQueryData(
      caseTemplatesQueries.listByWorkspaceId({
        workspace_id: currentWorkspace.id,
      }),
    );
  },
  component: CaseTemplatesPage,
});
